import React, { useEffect, useState } from "react";
import Header from "../Shard/Navbar/Header";
import SearchHeading from "./HomePages/Search/SearchHeading";
import Service from "./Service/Service";
import VideoPlayer from "./VideoPlayer/VideoPlayer";
import "./Home.css";
import Vehicle from "./Vehicle/Vehicle";
import ShipWith from "./ShipWith/ShipWith";
import Client from "./Clients/Client";
import Articles from "./Articles/Articles";
import Footer from "../Shard/Footer/Footer";
import Loader from "../Pages/Loader/Loader";

const Home = ({
  isShaw,
  setIsShaw,
  modalOpen,
  setModalOpen,
  setLoginModalOpen,
  equipmentsData,
  equipmentLoading,
  productData,
  vehicleData,
}) => {
  console.log(
    localStorage.getItem("quoteData")
      ? JSON.parse(localStorage.getItem("quoteData"))
      : " "
  );
  return (
    <div className="homepage">
      <Header
        isShaw={isShaw}
        setIsShaw={setIsShaw}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        setLoginModalOpen={setLoginModalOpen}
      />
      {equipmentLoading ? (
        <Loader />
      ) : (
        <>
          <SearchHeading
            equipmentsData={equipmentsData}
            productData={productData}
            vehicleData={vehicleData}
          />
          <Service />
          <Vehicle />
          <VideoPlayer />
          <ShipWith />
          <Client />
          <Articles />
        </>
      )}
      <Footer />
    </div>
  );
};

export default Home;
